import axios from "axios";
import * as settingTypes from "../../types/user/settingTypes";

//Add Setting
export const userAddSettingAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingTypes.USER_ADD_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/setting/create`,
        {},
        config
      );
      // console.log(data);
      dispatch({
        type: settingTypes.USER_ADD_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingTypes.USER_ADD_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Setting
export const userGetSettingAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingTypes.GET_USER_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/setting/show/data`,
        config
      );
      // console.log({ data });
      dispatch({
        type: settingTypes.GET_USER_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingTypes.GET_USER_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Mark
export const userAddMarkAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: settingTypes.UPDATE_MARK_IN_USER_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/${sharedUserInfo?.empCompanies[0]?.companyId?._id}/setting/mark`,
      formData,
      config
    );
    // console.log(data);
    dispatch({
      type: settingTypes.UPDATE_MARK_IN_USER_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: settingTypes.UPDATE_MARK_IN_USER_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Add Work
export const userAddWorkingAction =
  (companyId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingTypes.ADD_WORKING_FROM_IN_USER_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/setting/working/add`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: settingTypes.ADD_WORKING_FROM_IN_USER_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingTypes.ADD_WORKING_FROM_IN_USER_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Work
export const userGetPayrollSettingAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingTypes.GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${companyId}/setting/payroll/`,
        config
      );
      // console.log(data);
      dispatch({
        type: settingTypes.GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingTypes.GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get All Company Setting
export const userGetAllCompanySettingAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: settingTypes.GET_COMPANY_ALL_SETTING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/${sharedUserInfo?.empCompanies[0]?.companyId?._id}/setting/all/company/`,
        config
      );
      dispatch({
        type: settingTypes.GET_COMPANY_ALL_SETTING_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: settingTypes.GET_COMPANY_ALL_SETTING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
